<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">仪器设备采购管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <el-tag>{{$refs.organDia?$refs.organDia.nodeArrName:''}}</el-tag>&nbsp;<el-button type="primary" @click="dialogOpen">选择</el-button>
        </el-form-item> -->
        <!-- <el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="处理状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择处理状态">
            <el-option v-for="item in $store.state.applyStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增申请</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训设备采购申请模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="action" :params="params" :btnTitle="btnTitle"></Importt>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column fixed prop="type" label="采购类别" min-width="150">
        </custom-table-column>
        <custom-table-column label="审核状态" prop="status" width="150" :formatter="format_status_str">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" width="180">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="180">
        </custom-table-column>
        <custom-table-column prop="grade" label="年级" width="160">
        </custom-table-column>
        <custom-table-column prop="class_num" label="班级数" width="160">
        </custom-table-column>
        <custom-table-column prop="total_amount" label="总采购金额" width="160">
        </custom-table-column>
        <custom-table-column prop="created_at" label="创建时间" width="180">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="handleDetailClick(scope.row)" type="text" size="small">采购详情</el-button>
            <!-- <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button> -->
            <el-button v-if="scope.row.status == 'apply'" @click="handleApply(scope.row.id, 'pass')" type="text"
              size="small">通过</el-button>
            <el-button v-if="scope.row.status == 'apply'" @click="handleApply(scope.row.id, 'refuse')" type="text"
              size="small">拒绝</el-button>
            <el-button v-if="scope.row.status == 'apply'" @click="handleDelet(scope.row.id)" type="text"
              size="small">删除</el-button>
            <el-button @click="handleExportById(scope.row.id)" type="text" size="small">导出清单</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery">
      </OrganDialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="采购类别" prop="type">
          <el-input v-model="ruleForm.type" placeholder="请输入采购类别" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="学年学期" prop="term">
          <el-select v-model="ruleForm.term" clearable placeholder="请选择学年学期" style="width:216px;">
            <el-option v-for="(item, index) in $store.state.termms" :key="index" :label="item.term"
              :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="院系专业" prop="major">
          <el-input v-model="selectName" placeholder="请选择院系+专业" style="width:552px;" @focus="dialogOpen"
            @clear="handeleClear" clearable></el-input>
        </el-form-item>
        <el-form-item label="年  级" prop="grade">
          <el-input v-model="ruleForm.grade" placeholder="请输入年级" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="班级数" prop="class_num">
          <el-input v-model.number="ruleForm.class_num" placeholder="请输入班级数" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="总采购金额" prop="total_amount">
          <el-input v-model="ruleForm.total_amount" :disabled="true" placeholder="请先输入总采购金额"
            style="width:198px;"></el-input> 元
        </el-form-item>
        <div style="background:#edf4ff;padding:32px 0;width:100%;border-radius: 6px;">
          <p style="text-indent:48px;font-size:16px;margin-bottom:32px;">采购清单</p>
          <div v-for="(item, index) in plist" :key="index"
            style="width:100%;border: 3px solid #3176db;padding: 30px 0;box-sizing: border-box;border-radius: 15px;margin-bottom:4px;">
            <el-form :model="item" :rules="rules1" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
              <el-form-item label="名  称" prop="mc">
                <el-input v-model="item.mc" placeholder="请输入名称" style="width:216px;"></el-input>
              </el-form-item>
              <el-form-item label="类  型" prop="lx">
                <el-input v-model="item.lx" placeholder="请输入类型" style="width:216px;"></el-input>
              </el-form-item>
              <el-form-item label="厂  商" prop="cs">
                <el-input v-model="item.cs" placeholder="请输入厂商" style="width:216px;"></el-input>
              </el-form-item>
              <el-form-item label="规  格" prop="gg">
                <el-input v-model="item.gg" placeholder="请输入规格" style="width:216px;"></el-input>
              </el-form-item>
              <el-form-item label="数  量" prop="sl">
                <el-input v-model.number="item.sl" @input="handleInput(item)" placeholder="请输入数量"
                  style="width:216px;"></el-input>
              </el-form-item>
              <el-form-item label="单  位" prop="dw">
                <el-input v-model="item.dw" placeholder="请输入单位" style="width:216px;"></el-input>
              </el-form-item>
              <el-form-item label="单  价" prop="dj">
                <el-input v-model="item.dj" placeholder="请输入单价" @input="handleInput(item)"
                  style="width:198px;"></el-input>
                元
              </el-form-item>
              <el-form-item label="总  价" prop="zj">
                <el-input v-model="item.zj" :disabled="true" placeholder="请输入总价" style="width:198px;"></el-input> 元
              </el-form-item>
              <el-form-item label="所属课程" prop="sskc">
                <el-input v-model="item.sskc" placeholder="请输入所属课程" style="width:216px;"></el-input>
              </el-form-item>
              <el-form-item :label="`${$store.state.themeTitle}室`" prop="sxs">
                <el-select v-model="item.sxs" style="width:216px;" :placeholder="`请选择${$store.state.themeTitle}室`">
                  <el-option v-for="itemm in $store.state.trainRooms" :key="itemm.id" :label="itemm.training_name"
                    :value="itemm.training_name"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div style="margin-top:12px;text-align:center;">
              <el-button type="danger" @click="handleItemDelete(item, index)" size="mini">删除</el-button>
            </div>
          </div>
          <div style="margin-top:12px;text-align:center;">
            <el-button size="mini" @click="handleItemAdd()">新增一条+</el-button>
          </div>
        </div>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="采购详情" :visible.sync="detailDialogVisible" width="746px">
      <el-descriptions class="margin-top" title="申请单" direction="vertical" :column="4" :size="size" border>
        <el-descriptions-item>
          <template slot="label">采购类别 </template> {{ rowObj.type }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">学年学期 </template> {{ rowObj.term }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">年 级 </template> {{ rowObj.grade }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">班级数 </template> {{ rowObj.class_num }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">总采购金额 </template> {{ rowObj.total_amount }}元
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">院系专业 </template> {{ rowObj.structure_1 }}-{{ rowObj.major }}
        </el-descriptions-item>
      </el-descriptions>
      <p style="font-size: 16px;font-weight: 700;color:#111;margin-top:32px;margin-bottom:20px;">采购清单</p>
      <el-descriptions class="margin-top" title="" style="margin-bottom:16px;" v-for="(item, index) in listArr"
        :key="index" direction="vertical" :column="5" :size="size" border>
        <el-descriptions-item>
          <template slot="label">名 称 </template> {{ item.mc }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">类 型 </template> {{ item.lx }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">厂 商 </template> {{ item.cs }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">规 格 </template> {{ item.gg }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">数 量 </template> {{ item.sl }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">{{ $store.state.themeTitle }}室 </template> {{ item.sxs }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">课 程 </template> {{ item.sskc }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">单 位 </template> {{ item.dw }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">单 价 </template> {{ item.dj }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">总 价 </template> {{ item.zj }}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteTarinRoom">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
  </div>
</template>

<script>
import { baseUrlt } from "../../api";
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinFormatter],
  data() {
    return {
      formInline: {
        structure_1: '',
        major: '',
        status: '',
      },
      size: 'small',
      detailDialogVisible: false,
      levell: [1, 2],
      selectName: '',
      organLabel: '',
      ruleForm: {
        structure_1: '',
        major: '',
        term: '',
        grade: '',
        class_num: '',
        type: '',
        total_amount: 0,
        list: '',
      },
      rowObj: {},
      plist: [],
      classRooms: [],
      rules: {
        grade: [{ required: true, message: '请输入年级', trigger: 'blur' }],
        major: [{ required: true, message: '请选择院系+专业' }],
        term: [{ required: true, message: '请选择学年学期', trigger: 'change' }],
        total_amount: [
          { required: true, message: '请输入总采购金额', trigger: 'blur' },
          { validator: this.checkfloat, trigger: 'blur' },
        ],
        class_num: [{ required: true, message: '请输入班级数', trigger: 'blur' }],
        // training_room: [{ required: true, message: `请输入所属${this.$store.state.themeTitle}室`, trigger: 'change' }],
        type: [{ required: true, message: '请输入采购类别', trigger: 'blur' }],
      },
      rules1: {
        mc: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        sl: [
          { required: true, message: '数量不能为空', trigger: 'blur' },
          { type: 'number', message: '数量必须为数字值', trigger: 'blur' },
        ],
        dj: [
          { required: true, message: '请输入单价', trigger: 'blur' },
          { validator: this.checkfloat, trigger: 'blur' },
        ],
        zj: [{ required: true, message: '请先输入数量和单价', trigger: 'blur' }],
      },
      action: '',
      downloadUrl: 'template/实训设备采购申请模版.xlsx',
      downloadName: '实训设备采购申请模版.xlsx',
      btnTitle: '导入实训设备采购申请数据',
      listArr: [],
      exportUrl: '',
    };
  },
  created() {
    this.action = `${this.baseUrlt}api/device/purchase2/getTemplate`;
    // this.$store.dispatch('getTarinMent');
    // this.$store.dispatch('getTermms');
  },
  watch: {
    plist: {
      handler: function (val) {
        let total = 0;
        val.map((item) => {
          total += item.zj;
        });
        this.ruleForm.total_amount = total;
        this.ruleForm.list = JSON.stringify(val);
      },
      deep: true,
    },
  },
  computed: {
    total_price() {
      // this.total_price = this.quantity*this.price
      return (this.ruleForm.quantity * this.ruleForm.price * 1000) / 1000;
    },
  },
  mounted() { },
  methods: {
    handleExportById(id) {
      this.exportUrl = `${baseUrlt}api/device/purchase2/export?id=${id}`
      this.handleExportByUrl()

    },
    handleItemDelete(item, index) {
      this.plist.splice(index, 1);
    },
    handleApply(id, status) {
      let str = '通过';
      if (status == 2) {
        str = '拒绝';
      }
      this.confirmBox('warning', `此操作将${str}该采购申请，是否继续`, { id, status }, this.setStatus);
    },
    async setStatus(params) {
      let res = await this.$api.update.operDevicePurchase(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '处理成功！',
        });
        this.getList();
      }
    },
    handleDetailClick(row) {
      this.rowObj = row;
      this.listArr = JSON.parse(row.list);
      this.detailDialogVisible = true;
    },
    handleInput(item) {
      item.zj = item.dj * item.sl;
      // return  item.zj
    },
    handleItemAdd() {
      this.plist.push({ lx: '', mc: '', cs: '', gg: '', sl: 0, dw: '', dj: 0, zj: 0, sskc: '', sxs: '' });
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_room = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    async deleteTarinRoom() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deletDevicePurchase(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createTarinRoom() {
      // console.log(this.total_price)
      // return
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      // params.total_price = this.total_price;
      // if (params.buy_at) {
      //   let timee = params.buy_at.getTime() / 1000;
      //   params.buy_at = this.$until.getTimeStr(timee, '-');
      // }
      let res = await this.$api.creat.creatDevicePurchaseAdd(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateTarinRoom() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      // params.total_price = this.total_price;
      let res = await this.$api.update.updateTarinRoom(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    // getOrganList() {
    //   this.beforeGetOrgan()
    // },
    handleQuery() {
      this.beforeQuery()
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getDevicePurchaseAdmin(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createTarinRoom();
          } else if (this.type == 'edit') {
            this.updateTarinRoom();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
